import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navbar from './navbar';
// import './matchtags.css';

const AllMatchTags = () => {
  const [tags, setTags] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTags = async () => {
      const res = await axios.get('https://backend.aubattle.com/api/match-tags');
      setTags(res.data);
    };
    fetchTags();
  }, []);

  return (
    <div className="tag-page">
      <Navbar />
      <h2 className="section-title">Select Match Category</h2>
      <div className="tags-container">
        {tags.map((tag) => (
          <div 
            key={tag.id} 
            className="tag-card"
            onClick={() => navigate(`/tags/${tag.name}`)}
          >
            {tag.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllMatchTags;
